import React from 'react';
import Script from 'next/script';
import PropTypes from 'prop-types';

// TODO: set correct domain values for each environment
var SimonScript = function SimonScript(_ref) {
  var storageEnvironment = _ref.storageEnvironment;
  var simonStorageConfiguration = {
    Zillow: {
      partnerId: '678699254b5f7e42743738daef1770d6dcf2abd8',
      jsScript: 'https://static.simonsignal.com/simon-zil-min.js',
      domain: '.zillow.com'
    },
    ZillowHomeLoans: {
      partnerId: '28cfa166d9458c2837f77348ad8903501ad7c60d',
      jsScript: 'https://static.simonsignal.com/simon-zhl-min.js',
      domain: '.zillow.com'
    },
    ZillowSandBox: {
      partnerId: '4b618a5c5579f17752bf385ed61558a58f390f87',
      jsScript: 'https://static.simonsignal.com/zil',
      domain: '.zillow.com'
    }
  };
  var _simonStorageConfigur = simonStorageConfiguration[storageEnvironment],
    partnerId = _simonStorageConfigur.partnerId,
    jsScript = _simonStorageConfigur.jsScript,
    domain = _simonStorageConfigur.domain;
  return /*#__PURE__*/React.createElement(Script, {
    id: "sf_" + partnerId
  }, "\n\t\tvar _sd = _sd || {};\n\t\t_sd.partnerId = '" + partnerId + "';\n\t\t_sd.domain = '" + domain + "';\n\t\t_sd.environment = '" + storageEnvironment + "';\n\t\t_sd.debug = true;\n\t\t_sd.behaviors = {};\n\t\t(function(s,i,m){\n\t\t    w=window;d=document;n='script';l=Array.prototype.slice;\n\t\t    w._sd.lib=i;w.SimonData=s;\n\t\t    w[s]||(w[s]={\n\t\t    send:function(){(w[s].q=w[s].q||[]).push(arguments)},\n\t\t    identify:function(){a=l.call(arguments);a.unshift('identify');w[s].send.apply(null,a)},\n\t\t    track:function(){a=l.call(arguments);a.unshift('track');w[s].send.apply(null,a)}\n\t\t    });\n\t\t    t=d.createElement(n);t.src=i;\n\t\t    o=d.getElementsByTagName(m)[0];o.parentNode.insertBefore(t,o)\n\t\t})('sd','" + jsScript + "','script');\n\t ");
};
SimonScript.propTypes = process.env.NODE_ENV !== "production" ? {
  storageEnvironment: PropTypes.string.isRequired
} : {};
var SimonScript$1 = SimonScript;

export { SimonScript$1 as default };
